import { TaskPermission } from '@anb/ng-auth';
import { Pipe, PipeTransform } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({ name: 'isAllowed' })
export class IsAllowedPipe implements PipeTransform {
  constructor(private readonly permissionService: NgxPermissionsService) {}

  transform(permission: string | TaskPermission): Observable<boolean> {
    const permissionAsString = typeof permission === 'string' ? permission : permission.taskPermissionAsString;
    return this.permissionService.permissions$.pipe(
      map((p) => {
        if (!p) return false;
        return !!p[permissionAsString];
      }),
    );
  }
}
